<template>
  <div>
    <el-menu :default-active="activeIndex" mode="horizontal" background-color="#FAFAFA" text-color="#3a3a3a"
      active-text-color="#FAFAFA" router @select="handleSelect" style="height: 80px;">
      <span index="/" background-color="#FAFAFA" active-text-color="#FAFAFA" style="display: inline-block;float: left;margin-right: 15px;margin-left: 10px;height: 80px;"
        @click="tapLogo">
        <img style="display:inline-block;width: 280px;margin-top: 12px;" :src="bgp"></img>
      </span>
      <el-menu-item index="/home">首页</el-menu-item>
      <el-menu-item index="/serverCenter">服务中心</el-menu-item>
      <el-menu-item index="/personCenter">个人中心
        <el-badge v-if="todo_count>0" class="mark" :value="todo_count" />
      </el-menu-item>
      <div class="menu-right" v-if="hasLogin">
        <el-dropdown>
          <span class="el-dropdown-link">
            <span class="user-name">{{user.name}}</span><i class="el-icon-arrow-down el-icon--right" style="color:#3a3a3a;"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <router-link to="/signin" @click.native="logout">退出登录</router-link>
            </el-dropdown-item>

            <el-dropdown-item>
              <span @click="toAdmin">后台管理</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div style="height: 80px;line-height: 80px;padding-right: 10px;
      font-size: 23px;font-weight: 900;color: #3F3793;float: right;">
        <span style="color:#000;">上海飞域</span>&nbsp;&nbsp;定制化实验室家具全流程质量和溯源管理系统
      </div>
    </el-menu>

    <div class="photo" v-if="$route.name=='home'">
      <el-carousel :interval="3000" indicator-position="outside" height="90vh">
        <el-carousel-item v-for="(item,index) in webBanner" :key="'ii'+index">
          <img style="width:100%;height: 90vh;" :src="item.image" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="content">
      <router-view :fun="borderData"></router-view>
    </div>

    <div class="footer">
      <Footer @valueObject="getFooterData" />
    </div>
  </div>
</template>
<script>
  import Footer from './Footer.vue'
  import {
    mapState
  } from 'vuex'

  export default {
    components: {
      Footer
    },
    data() {
      return {
        bgp: '',
        webBanner: '',
        borderData: '',
        screenWidth: '',
        screenHeight: ''
      }
    },
    computed: {
      ...mapState(['todo_count', 'user', 'hasLogin']),
      activeIndex: function() {
        return this.$route.path
      }
    },
    created() {
    },
    mounted() {
      // this.screenWidth = document.body.clientWidth
      // this.screenHeight = document.body.clientHeight
      // console.log('width is ' + this.screenWidth)
      // console.log('height is ' + this.screenHeight)
      // window.onresize = () => {
      //   return (() => {
      //     this.screenWidth = document.body.clientWidth
      //     this.screenHeight = document.body.clientHeight
      //     console.log('width is ' + this.screenWidth)
      //     console.log('height is ' + this.screenHeight)
      //   })()
      // }
      this.getSetting()
    },
    methods: {
      getSetting() {
        this.$http.getSetList({
          keys: 'website_logo,website_banners'
        }).then(res => {
          if (res.code === 0) {
            this.bgp = this.domain + '/upload/' + res.data.website_logo
            this.webBanner = JSON.parse(res.data.website_banners)
            for (var i in this.webBanner) {
              this.webBanner[i].image = this.domain + '/upload/' + this.webBanner[i].image
            }
          }
        })
      },
      handleSelect(key, keyPath) {},
      logout() {
        this.$store.commit('LOG_OUT')
      },
      getFooterData(data) {
        this.borderData = data
      },
      tapLogo() {
        this.$router.push('/home')
      },
      toAdmin() {
        // if (this.user.is_admin == 1) {
        //   window.location.href = '/admin/#/homePage'
        // } else {
        window.location.href = '/admin'
        // }
      }
    }
  }
</script>
<style scoped lang="scss">
  .content {
    background-color: #fafafa;
    padding: 10px;
    border-radius: 10px;
    width: 90%;
    margin: 0 auto;
    min-height: 800px;
  }

  .footer {
    background-color: rgb(54, 54, 54);
  }

  .menu-right {
    float: right;
    height: 80px;
    line-height: 80px;
    margin-right: 5px;
    font-size: 18px;
  }

  .user-name {
    color: #3a3a3a;
  }

  .el-menu-item {
    height: 80px;
    line-height: 80px;
    font-size: 16px;
  }

  .el-menu-item.is-active {
    background-color: rgb(63, 55, 147) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/header/Layout.vue